<!-- The overview is the first item in the sidebar
Only include sideBarBody content here
-->
@if (useCustom) {
  <ng-content></ng-content>
} @else {
  @for (attribute of attributeList; track attribute) {
    @if (attribute.context !== 'group') {
      <model-attribute
        [context]="attributeListContext"
        [config]="attribute"
        direction="column"
        (linkClicked)="handleModelAttributeClicks($event)"
      >
      </model-attribute>
    }
    @if (attribute.context === 'group') {
      <model-attribute
        [context]="attributeListContext?.group"
        [config]="attribute"
        (linkClicked)="handleModelAttributeClicks($event)"
        direction="column"
      >
      </model-attribute>
    }
  }
}
